<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>供应点管理</el-breadcrumb-item>
        <el-breadcrumb-item>交易管理</el-breadcrumb-item>
        <el-breadcrumb-item>交易查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form ref="listParamsForm" :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="订单编号：" prop="orderNo">
              <el-input style="width: 100%" size="small" v-model="listParams.orderNo"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="订单状态：" prop="orderStatus">
              <el-select clearable style="width: 100%" size="small" v-model="listParams.orderStatus">
                <el-option v-for="item in orderStatusList" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="电话号码：" prop="buyerMobile">
              <el-input size="small" v-model="listParams.buyerMobile" placeholder="请输入电话号码" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="领货日期：" prop="timeInterval">
              <date-picker-group v-model="listParams.timeInterval"></date-picker-group>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData">查询</el-button>

              <el-button style="margin-left: 20px" size="small" @click="resetForm('listParamsForm')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <!--<el-button-->
          <!--class="align-left"-->
          <!--type="primary"-->
          <!--size="small"-->
          <!--@click="exportExcel">-->
          <!--导出-->
          <!--</el-button>-->
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" ref="table" :data="tableData" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"></span>
          </template>
        </el-table-column>
        <!-- <el-table-column type="expand">
          <template slot-scope="{ row }">
            <el-table v-loading="goodLoading" :data="row.goodData" border>
              <el-table-column
                align="center"
                prop="productTitle"
                label="商品名称"
              />
              <el-table-column
                align="center"
                prop="productSpec"
                label="商品规格"
              />
              <el-table-column
                align="center"
                prop="productQuantity"
                label="商品数量"
              />
              <el-table-column
                align="center"
                prop="productPrice"
                label="商品销售价"
              />
              <el-table-column
                align="center"
                prop="subTotal"
                label="商品定金"
              />
              <el-table-column
                align="center"
                prop="subTotal"
                label="折扣优惠"
              />
              <el-table-column
                align="center"
                prop="tradeAmountTotal"
                label="商品核销金额"
              />
            </el-table>
          </template>
        </el-table-column> -->

        <el-table-column width="120" prop="orderNo" align="center" label="订单编号">
          <template slot-scope="scope">
            <div v-if="scope.row.orderNo">
              <div v-if="scope.row.orderNo.length > 10">
                <el-popover ref="popover1" placement="top-start" width="200" trigger="hover" :content="scope.row.orderNo"></el-popover>
                <el-button style="color: #606266" type="text" v-popover:popover1>{{ scope.row.orderNo | formatLimitLength }}</el-button>
              </div>
              <div v-else>{{ scope.row.orderNo }}</div>
            </div>
          </template>
        </el-table-column>

        <el-table-column width="120" prop="buyerMobile" align="center" label="买家信息" />
        <el-table-column prop="orderAmount" align="center" label="商品定金" />
        <el-table-column prop="levelDiscountAmount" align="center" label="折扣金额">
          <template slot-scope="{ row }">
            {{ row.levelDiscountAmount ? row.levelDiscountAmount : 0 }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="paymentAmount" align="center" label="支付金额" /> -->
        <el-table-column align="center" label="补差/退款">
          <template slot-scope="{ row }">
            {{ (row.paymentAmount * 1000 - row.amountTotal * 1000) / 1000 }}
          </template>
        </el-table-column>

        <el-table-column prop="supplyDate" align="center" width="200" label="领货日期" />

        <el-table-column prop="orderStatusDisplay" align="center" label="订单状态" />

        <el-table-column prop="paymentType" align="center" label="支付方式" />

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="linkToDetailPage(scope.row.orderId)"> 详情 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <DialogRefund :dialogVisible.sync="dialogVisibleRefund" :orderItem="refundItem" @success="loadTableData" />
  </div>
</template>

<script>
import DialogRefund from "./components/DialogRefund";
import { featchOderdetail } from "./api";
export default {
  components: { DialogRefund },

  data() {
    return {
      listParams: {
        supplyId: "",
        orderNo: "",
        orderStatus: "",
        paymentType: "",
        timeInterval: ["", ""],
        siteId: "",
        buyerMobile: "",
        supplyLevelId: "",
      },
      logisticsSiteIdList: [],
      levelList: [],
      orderStatusList: [
        { label: "全部", value: "" },
        { label: "已取消", value: "0" },
        { label: "待付款", value: "1" },
        { label: "待发货", value: "2" },
        { label: "待收货", value: "3" },
        { label: "待补差", value: "4" },
        { label: "待退款", value: "5" },
        { label: "退款中", value: "6" },
        { label: "已完成", value: "7" },
        { label: "交易关闭", value: "8" },
      ],
      payWayList: [
        { label: "全部", value: "" },
        { label: "支付宝支付", value: "alipay" },
        { label: "微信支付", value: "wechatpay" },
        { label: "银联支付", value: "unionpay" },
        { label: "建行支付宝", value: "ccbpay_alipay" },
        { label: "建行微信支付", value: "ccbpay_wechatpay" },
        { label: "建行龙卡支付", value: "ccbpay_drogonpay" },
      ],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      levelPager: {
        pageIndex: 1,
        pageSize: 99,
      },
      dialogVisibleRefund: false,
      refundItem: {},
      goodData: [],
      goodLoading: false,
    };
  },
  mounted() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.listParams.siteId = this.$route.params.supplyCentreId;
    this.loadTableData();
  },
  methods: {
    /**
     * 懒加载商品列表
     */
    load(tree) {
      this.goodLoading = true;
      featchOderdetail(this, { orderId: tree.orderId })
        .then(res => {
          tree.goodData = res;
          this.goodLoading = false;
        })
        .catch(error => {
          console.err(error);
          this.goodLoading = false;
        });
    },
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      });
      bodyParams.supplyStartDate = bodyParams.timeInterval[0];
      bodyParams.supplyEndDate = bodyParams.timeInterval[1];
      delete bodyParams.timeInterval;
      for (const i in bodyParams) {
        if (bodyParams[i] === "" || bodyParams[i] === undefined) {
          delete bodyParams[i];
        }
      }
      this.$http({
        url: global.apiUrl + "/logistics/order-list",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.orderList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * 导出交易查询列表EXCEL
     */
    exportExcel() {},
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 跳转至详情页
     * @param orderId
     */
    linkToDetailPage(orderId) {
      this.$router.push({
        name: "supplyCentreTradeInquireDetail",
        query: {
          id: orderId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
